<div class="widget form-group" [ngSwitch]="widget.type">
  <p *ngSwitchDefault [innerHTML]="message"></p>
  <legend *ngSwitchCase="'section'" [innerHTML]="message"></legend>
</div>



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/message.widget.html